export default __webpack_public_path__ + "static/media/Growth_Heifer_Model.85a7c0b0.jpg";